import React, { FunctionComponent } from 'react';
import { useParams } from 'react-router-dom';
import LegacyView from '../../../../components/legacyView/LegacyView';

const Route: FunctionComponent = () => {
    const { rideId }: {rideId: string} = useParams();

    return (
        <LegacyView
            path={`/rides/${rideId}/change/route`}
            title={`Ride ${rideId}: Change route`}
        />
    );
};

export default Route;
